import { Link } from "react-router-dom";
import "./App.css";
import Footer from "./Footer";
import myData from "./data.json";
import * as React from "react";

function App() {
  const parsedData = JSON.parse(myData);
  const [prod1, setProduct1] = React.useState({});
  const [prod2, setProduct2] = React.useState({});
  return (
    <div className="container">
      <div className="App">
        <h1>Compare Protein Brands</h1>
        <p>
          <Link to="data">See full data </Link>
        </p>
        <label>Select Product Brand</label>
        <select
          onChange={(e) => {
            setProduct1(parsedData[e.target.value]);
          }}
        >
          {parsedData.map((item, i) => (
            <option value={i}>
              {item.ManufacterName} - {item.ProductName}
            </option>
          ))}
        </select>
        <br></br>
        {Object.keys(prod1).length === 0 ? null : (
          <>
            <h4>VS</h4>
            <label>Compare Product Brand</label>
            <select
              onChange={(e) => {
                setProduct2(parsedData[e.target.value]);
              }}
            >
              {parsedData.map((item, i) => (
                <option value={i}>
                  {item.ManufacterName} - {item.ProductName}
                </option>
              ))}
            </select>
          </>
        )}
        {Object.keys(prod1).length === 0 ||
        Object.keys(prod2).length === 0 ? null : (
          <div>
            <br></br>
            <h3>Results</h3>
            <table className="compareTable">
              <tr>
                <th></th>
                <th>{prod1.ProductName}</th>
                <th>{prod2.ProductName}</th>
              </tr>
              <tr>
                <td>
                  <b>Manufacturer</b>
                </td>
                <td>{prod1.ManufacterName}</td>
                <td>{prod2.ManufacterName}</td>
              </tr>
              <tr>
                <td>
                  <b>Labelled Protein</b>
                </td>
                <td>{prod1.Labelled}%</td>
                <td>{prod2.Labelled}%</td>
              </tr>
              <tr>
                <td>
                  <b>Actual Protein</b>
                </td>
                <td>{prod1.Actual}%</td>
                <td>{prod2.Actual}%</td>
              </tr>
              <tr>
                <td>
                  <b>Mislabelled?</b>
                </td>
                <td>{prod1.Mislabelled}</td>
                <td>{prod2.Mislabelled}</td>
              </tr>
              <tr>
                <td>
                  <b>Arsenic</b>
                </td>
                <td>{prod1.Arsenic}</td>
                <td>{prod2.Arsenic}</td>
              </tr>
              <tr>
                <td>
                  <b>Cadium</b>
                </td>
                <td>{prod1.Cadium}</td>
                <td>{prod2.Cadium}</td>
              </tr>
              <tr>
                <td>
                  <b>Lead</b>
                </td>
                <td>{prod1.Lead}</td>
                <td>{prod2.Lead}</td>
              </tr>
              <tr>
                <td>
                  <b>Copper</b>
                </td>
                <td>{prod1.Copper}</td>
                <td>{prod2.Copper}</td>
              </tr>
              <tr>
                <td>
                  <b>Recommended Buying?</b>
                </td>
                <td>{prod1.RecommendedBuying}</td>
                <td>{prod2.RecommendedBuying}</td>
              </tr>
            </table>
            <section className="caveats">
              <div className="box">
                <br></br>
                <h5>Notes</h5>
                <ul>
                  <li>
                    Possible values of <b>Recommended Buying?</b>
                    <ul>
                      <li>Yes</li>
                      <li>Yes with Caution</li>
                      <li>Not Bad</li>
                      <li>No</li>
                    </ul>
                  </li>
                  <li>
                    Possible values of <b>Mislabelled?</b>
                    <ul>
                      <li>Yes, severe</li>
                      <li>Yes, mild</li>
                      <li>No</li>
                    </ul>
                  </li>
                  <li>
                    <b>BLQ</b> stands for - Below the Limit of Quantification.
                  </li>
                </ul>
              </div>
            </section>
          </div>
        )}
        <Footer />
      </div>
    </div>
  );
}

export default App;
